/**
 * Removes legacy actor prefixes before timeline notes are rendered. Actor
 * identity already has its own UI field, so repeating it inside note text makes
 * audit and CRM histories harder to scan.
 */
export function cleanNoteText(note, actorName) {
  if (!note) return "";
  const actor = String(actorName || "").trim();
  const prefixes = [
    `${actor} added note:`,
    `${actor} logged:`,
    `${actor} called:`,
    "Rohan Sharma added note:",
    "Demo Agent logged:",
  ];
  let cleaned = String(note);
  for (const prefix of prefixes) {
    if (prefix && cleaned.toLowerCase().startsWith(prefix.toLowerCase())) {
      cleaned = cleaned.substring(prefix.length).trim();
    }
  }
  const genericPrefix = cleaned.match(/^[A-Za-z0-9\s]+ (?:added note|logged|called to|called):\s*/i);
  return genericPrefix ? cleaned.substring(genericPrefix[0].length).trim() : cleaned;
}
